export interface TimelineContextMenuPosition {
  x: number;
  y: number;
  stageLabel: string;
  substepLabel?: string | null | undefined;
}

export interface TimelineContextMenuProps {
  position: TimelineContextMenuPosition | null;
  retryPending: boolean;
  onRetrySingle: () => void;
  onRetryFromHere: () => void;
}

export function TimelineContextMenu(props: TimelineContextMenuProps): JSX.Element | null {
  if (!props.position) return null;
  return (
    <div
      className="fixed z-[65] min-w-64 rounded-md border bg-background p-1 shadow-lg"
      style={{
        left: Math.min(props.position.x, window.innerWidth - 280),
        top: Math.min(props.position.y, window.innerHeight - 140),
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="border-b px-3 py-2 text-xs text-muted-foreground">
        {props.position.substepLabel
          ? `${props.position.stageLabel} / ${props.position.substepLabel}`
          : props.position.stageLabel}
      </div>
      <button
        type="button"
        className="flex w-full items-center rounded-sm px-3 py-2 text-left text-sm hover:bg-muted"
        onClick={props.onRetrySingle}
        disabled={props.retryPending}
      >
        Retry this step alone
      </button>
      <button
        type="button"
        className="flex w-full items-center rounded-sm px-3 py-2 text-left text-sm hover:bg-muted"
        onClick={props.onRetryFromHere}
        disabled={props.retryPending}
      >
        Retry from this point on
      </button>
    </div>
  );
}
